export function Footer({ onNavigate }: { onNavigate: (p: "contact") => void }) {
    return (
        <footer className="bg-slate-900 text-slate-400 pt-12 pb-8 px-6">
            <div className="max-w-[1200px] mx-auto flex justify-between items-start flex-wrap gap-8 max-md:flex-col">
                <div>
                    <div className="text-xl font-extrabold text-white mb-2">
                        commander<span className="text-orange-500">.</span>appitep<span className="text-orange-500">.</span>fr
                    </div>
                    <p className="text-[0.88rem] text-slate-400 max-w-[320px] leading-relaxed">
                        Applications web de commande en ligne pour food trucks, camion pizzas et snacks. Zéro commission, tout inclus, opérationnel en 48h.
                    </p>
                </div>
                <div>
                    <ul className="list-none flex flex-row flex-wrap gap-4">
                        {["Avantages", "Fonctionnalités", "Tarif", "FAQ"].map(l => (
                            <li key={l}><a href={`#${l.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")}`} className="text-slate-400 text-[0.9rem] hover:text-white transition-colors no-underline">{l}</a></li>
                        ))}
                        <li><button onClick={() => onNavigate("contact")} className="text-slate-400 text-[0.9rem] hover:text-white transition-colors bg-transparent border-none cursor-pointer p-0">Contact</button></li>
                    </ul>
                </div>
            </div>
            <div className="max-w-[1200px] mx-auto mt-8 pt-6 border-t border-white/10 text-center text-[0.82rem] text-slate-400">
                <p>&copy; 2026 commander.appitep.fr — Tous droits réservés.</p>
            </div>
        </footer>
    );
}
